import axios from "axios";
import { toast } from "react-toastify";

import {
  FileBuildRequestBodyType,
  FileBuildRequestPathParamsType,
  FileBuildResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const fileBuild = async (
  payload: ApiRequest<FileBuildRequestBodyType, FileBuildRequestPathParamsType>
) => {
  const resp = await api.post<
    FileBuildResponseBodyType,
    FileBuildRequestBodyType
  >(
    `/v2/build-${payload.pathParams.type}`,
    // `/build-${data.fileType}`,
    {
      variations: payload.body.variations,
      selectedProducts: payload.body.selectedProducts,
      name: payload.body.name,
      experienceId: payload.body.experienceId,
      forExternalPriceUpload: payload.body.forExternalPriceUpload,
    }
  );
  return resp.data;
};

export const useFileBuild = () => {
  return useMutation<
    FileBuildResponseBodyType,
    Error,
    ApiRequest<FileBuildRequestBodyType, FileBuildRequestPathParamsType>,
    any
  >({
    mutationFn: async (data) => fileBuild(data),
    onError: (error) => {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 503) {
          // Do nothing
        } else {
          toast.error("Error, Unable to Download File");
        }
      }
    },
  });
};
